import { Flex, Tag, Typography } from 'antd';
import { FileOutlined } from '@ant-design/icons';
import AntDButton from 'src/components/Button';

export const GridTableHeader = ({
  tableColumns,
  onClick,
  title,
  status,
  timesheetNotes,
  disabled,
}) => {
  return (
    <Flex>
      <Flex
        align="center"
        gap="small"
        justify="flex-start"
        style={{ width: '33%' }}
      >
        {timesheetNotes ? (
          <AntDButton
            type="link"
            onClick={onClick}
            disabled={disabled}
            prefixIcon={<FileOutlined />}
            statusOnComplete={title}
            htmlType={'button'}
            style={{
              padding: 0,
            }}
          />
        ) : (
          ' '
        )}
        {status === 1 ? (
          <Tag color="#F9D648" style={{ color: 'black' }}>
            Time Sheet Submitted
          </Tag>
        ) : status === 2 ? (
          <Tag color="#28A745">Time Sheet Approved</Tag>
        ) : status === 3 ? (
          <Tag color="#D9534F">Time Sheet Rejected</Tag>
        ) : (
          <span style={{ width: '120px', display: 'inline-block' }}></span>
        )}
      </Flex>

      {tableColumns.map((column, index) => (
        <Typography.Text
          strong
          key={`${column.name}-${index}`}
          style={{
            fontSize: '.75rem',
            padding: '1rem',
            flex: 1,
          }}
        >
          {column.name}
        </Typography.Text>
      ))}
    </Flex>
  );
};
